// src/services/authListener.js

import router from '@/router';
import { supabase } from '@/supabase';

export const initializeAuthListener = () => {
    supabase.auth.onAuthStateChange((event) => {
        if (event === 'SIGNED_OUT') {
            localStorage.clear();
            // sessionStorage.clear();
            router.replace('/auth/login');
        }
    });
};